import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Modal, Spinner } from 'react-bootstrap'
import {
  deleteSecret,
} from '../../../../features/aws/awsSecretsManagerSlice'
import {
  deletePublicKey,
} from '../../integrationsSlice'
import { toast } from 'react-toastify'

export default function StripeUninstallModal({ visible, closeModal, integration }) {
  const dispatch = useDispatch()
  const { channel, ppKeys } = integration || {}

  const [isProcessing, setIsProcessing] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [showError, setShowError] = useState(false)

  const handleConfirm = async () => {
    setIsProcessing(true)
    setShowError(false)

    try {
      for (const key of ppKeys || []) {
        if (key.keyId) {
          try {
            await dispatch(deleteSecret({ secretId: key.keyId })).unwrap()
          } catch {}
          try {
            await dispatch(deletePublicKey({ keyId: key.keyId })).unwrap()
          } catch {}
        }
      }
      setCompleted(true)
      toast.success('Stripe account disconnected')
    } catch (err) {
      console.error('Error disconnecting Stripe:', err)
      setShowError(true)
    } finally {
      setIsProcessing(false)
    }
  }

  const handleClose = () => {
    closeModal()
    if (completed) {
      window.location.reload()
    }
  }

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Body>
        <div className="tw-p-6">
          <h2 className="tw-text-xl tw-mb-6">Disconnect {channel}</h2>
          {showError && <p className="tw-text-red-600 tw-mb-4">Error disconnecting integration. Please try again.</p>}
          <p className="tw-mb-4">
            {completed
              ? `${channel} has been disconnected.`
              : 'Are you sure you want to disconnect your Stripe account? This will remove your stored API key.'}
          </p>
          <div className="tw-flex tw-justify-end tw-space-x-2">
            <Button variant="secondary" size="sm" onClick={handleClose}>
              {completed ? 'Done' : 'Cancel'}
            </Button>
            {!completed && (
              <Button variant="danger" size="sm" onClick={handleConfirm} disabled={isProcessing}>
                {isProcessing ? (
                  <>
                    <Spinner animation="border" size="sm" className="tw-mr-2" />
                    Disconnecting...
                  </>
                ) : (
                  'Disconnect'
                )}
              </Button>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
